module.exports = __webpack_public_path__ + "t.no1.98689f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/t.no1.jpg
// module id = Nd1C
// module chunks = 0